import React, { useEffect, useState } from "react"
import styles from "./AISearchResultsFeedbackForm.scss"
import { Icon } from "antd"
import ReactGA from "react-ga4";
import { useDispatch } from "react-redux";
import {
  setAIFeedbackModalVisible,
  submitAIFeedback
} from "../../App/actions";

const Feedbacks = {
  like: "like",
  dislike: "dislike",
  none: null
}


export const AISearchResultsFeedbackForm = ({ queryParams, searchQuery }) => {
  const [feedbackClicked, setFeedbackClicked] = useState(Feedbacks.none)
  const dispatch = useDispatch()

  useEffect(() => {
    setFeedbackClicked(Feedbacks.none)
  }, [queryParams.current])

  const handleLikeClick = () => {
    setFeedbackClicked(feedbackClicked === Feedbacks.like ? Feedbacks.none : Feedbacks.like)
    dispatch(submitAIFeedback({ isAiSearchGood: true, searchQuery }))

    ReactGA.event({
      category: "AI pretraga",
      action: "Click",
      label: "Sviđa mu se"
    })

  }

  const handleDislikeClick = () => {
    setFeedbackClicked(feedbackClicked === Feedbacks.dislike ? Feedbacks.none : Feedbacks.dislike)
    dispatch(setAIFeedbackModalVisible(true))

    ReactGA.event({
      category: "AI pretraga",
      action: "Click",
      label: "Ne sviđa mu se"
    })

  }


  return (
    <div className={styles.glowBorder}>
      <div className={styles.wrapper}>
        <p className={styles.text}>Jeste li zadovoljni rezultatima AI pretrage?</p>
        <div className={styles.buttonsWrapper}>
          <button
            type="button"
            className={`${styles.button} ${feedbackClicked === Feedbacks.like ? styles.selectedButton : ""}`}
            onClick={handleLikeClick}
          >
            <Icon
              type="like"
              style={{ marginRight: 8 }}
            />
            <span>
              Da

            </span>
          </button>
          <button
            type="button"
            className={`${styles.button} ${feedbackClicked === Feedbacks.dislike ? styles.selectedButton : ""}`}
            onClick={handleDislikeClick}
          >
            <Icon
              type="dislike"
              style={{ marginRight: 8 }}
            />
            <span>
              Ne, potrebno je poboljšanje
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/containers/SearchPage/AISearchResultsFeedbackForm/AISearchResultsFeedbackForm.tsx